import "./styles/loading-screen.css";

export default function LoadingScreen() {
  return (
    <main>
      <div id="loading-screen">
        <div className="waviy">
          <span className="i-1">L</span>
          <span className="i-2">O</span>
          <span className="i-3">A</span>
          <span className="i-4">D</span>
          <span className="i-5">I</span>
          <span className="i-6">N</span>
          <span className="i-7">G</span>
          <span className="i-8">.</span>
          <span className="i-9">.</span>
          <span className="i-10">.</span>
        </div>
      </div>
    </main>
  );
}
